import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './card.css'

const Card = (props) => {
  const [ShowText, setShowText] = useState(false)
  return (
    <div className={`card-container Fade_in ${props.rootClassName} `}>
      <div
        onMouseEnter={() => setShowText(true)}
        onMouseLeave={() => setShowText(false)}
        className="card-container1 Cursor"
      >
        <img
          alt={props.image_name}
          src={props.image_url}
          loading="eager"
          className="card-image"
        />
        {ShowText && (
          <div className="card-container2">
            <span className="card-text">{props.Image_name}</span>
          </div>
        )}
      </div>
    </div>
  )
}

Card.defaultProps = {
  image_url:
    'https://images.unsplash.com/photo-1676883343977-5f8ecc36856c?ixid=Mnw5MTMyMXwwfDF8YWxsfDF8fHx8fHwyfHwxNjc3NjEwMTUx&ixlib=rb-4.0.3&w=400',
  rootClassName: '',
  Image_name: 'Text',
  image_name: 'sub_image',
}

Card.propTypes = {
  image_url: PropTypes.string,
  rootClassName: PropTypes.string,
  Image_name: PropTypes.string,
  image_name: PropTypes.string,
}

export default Card
